export default __webpack_public_path__ + "static/media/clockHsb.162c1bf2.svg";